//系统管理员端
const rootConfig = [{
    path: '/pages/index',
    component: () => import('@/pages/public/index'),
    children: [{
        path: '/',
        redirect: 'home',
        component: () => import('@/pages/home/index')
    },
    {
        path: 'home',
        name: 'home',
        component: () => import('@/pages/home/index'),
        meta: {
            title: '工作台'
        }
    },
    {
        path: 'account_information',
        name: 'account_information',
        component: () => import('@/pages/public/account_information'),
        meta: {
            title: '个人信息'
        }
    },
    {
        path: 'articles',
        component: () => import('@/pages/articles/index'),
        meta: {
            title: '文章管理'
        },
        children: [{
            path: '/',
            redirect: 'list',
            component: () => import('@/pages/articles/list')
        },
        {
            path: 'list',
            name: 'articles_list',
            component: () => import('@/pages/articles/list'),
            meta: {
                title: '文章列表'
            }
        },
        {
            path: 'classify',
            name: 'articles_classify',
            component: () => import('@/pages/articles/classify'),
            meta: {
                title: '文章分类'
            }
        },
        {
            path: 'add',
            name: 'articles_add',
            component: () => import('@/pages/articles/add'),
            meta: {
                title: '添加文章',
                need_path: '/pages/index/articles/list'
            }
        },
        {
            path: 'edit',
            name: 'articles_edit',
            component: () => import('@/pages/articles/edit'),
            meta: {
                title: '编辑文章',
                need_path: '/pages/index/articles/list'
            }
        }
        ]
    },
    {
        path: 'videoManage',
        component: () => import('@/pages/videoManage/index'),
        meta: {
            title: '宣传视频管理'
        },
        children: [{
            path: '/',
            redirect: 'list',
            component: () => import('@/pages/videoManage/list')
        },
        {
            path: 'list',
            name: 'video_list',
            component: () => import('@/pages/videoManage/list'),
            meta: {
                title: '视频列表'
            }
        },
        {
            path: 'classify',
            name: 'video_classify',
            component: () => import('@/pages/videoManage/classify'),
            meta: {
                title: '分类列表'
            }
        },
        {
            path: 'add',
            name: 'video_add',
            component: () => import('@/pages/videoManage/add'),
            meta: {
                title: '添加视频',
                need_path: '/pages/index/videoManage/list'
            }
        },
        {
            path: 'edit',
            name: 'video_edit',
            component: () => import('@/pages/videoManage/edit'),
            meta: {
                title: '编辑视频',
                need_path: '/pages/index/videoManage/list'
            }
        }
        ]
    },
    {
        path: 'news',
        component: () => import('@/pages/news/index'),
        meta: {
            title: '新闻管理'
        },
        children: [{
            path: '/',
            redirect: 'list',
            component: () => import('@/pages/news/list')
        },
        {
            path: 'list',
            name: 'news_list',
            component: () => import('@/pages/news/list'),
            meta: {
                title: '新闻列表'
            }
        },
        {
            path: 'add',
            name: 'news_add',
            component: () => import('@/pages/news/add'),
            meta: {
                title: '添加新闻',
                need_path: '/pages/index/news/list'
            }
        },
        {
            path: 'edit',
            name: 'news_edit',
            component: () => import('@/pages/news/edit'),
            meta: {
                title: '编辑新闻',
                need_path: '/pages/index/news/list'
            }
        }
        ]
    },
    {
        path: 'film',
        component: () => import('@/pages/film/index'),
        meta: {
            title: '影片管理'
        },
        children: [{
            path: '/',
            redirect: 'list',
            component: () => import('@/pages/film/list')
        },
        {
            path: 'list',
            name: 'film_list',
            component: () => import('@/pages/film/list'),
            meta: {
                title: '影片列表'
            }
        },
        {
            path: 'add',
            name: 'film_add',
            component: () => import('@/pages/film/add'),
            meta: {
                title: '添加影片',
                need_path: '/pages/index/film/list'
            }
        },
        {
            path: 'edit',
            name: 'film_edit',
            component: () => import('@/pages/film/edit'),
            meta: {
                title: '编辑影片',
                need_path: '/pages/index/film/list'
            }
        },
        {
            path: 'classify',
            name: 'classify_list',
            component: () => import('@/pages/film/classify'),
            meta: {
                title: '分类列表'
            }
        },
            // {
            //     path: 'prize',
            //     name: 'prize',
            //     component: () => import('@/pages/film/prize'),
            //     meta: {
            //         title: '奖项管理'
            //     }
            // }
        ]
    },
    {
        path: 'record',
        component: () => import('@/pages/record/index'),
        meta: {
            title: '展映排期'
        },
        children: [{
            path: '/',
            redirect: 'list',
            component: () => import('@/pages/record/list')
        },
        {
            path: 'list',
            name: 'record_list',
            component: () => import('@/pages/record/list'),
            meta: {
                title: '展映影片列表'
            }
        },
        {
            path: 'add',
            name: 'record_add',
            component: () => import('@/pages/record/add'),
            meta: {
                title: '添加展映影片',
                need_path: '/pages/index/record/list'
            }
        },
        {
            path: 'edit',
            name: 'record_edit',
            component: () => import('@/pages/record/edit'),
            meta: {
                title: '编辑展映影片',
                need_path: '/pages/index/record/list'
            }
        },
            // {
            //     path: 'classify',
            //     name: 'classify_list',
            //     component: () => import('@/pages/record/classify'),
            //     meta: {
            //         title: '展映主题分类'
            //     }
            // },
        ]
    },
    {
        path: 'forum',
        component: () => import('@/pages/forum/index'),
        meta: {
            title: 'IDF论坛'
        },
        children: [{
            path: '/',
            redirect: 'list',
            component: () => import('@/pages/forum/list')
        },
        {
            path: 'list',
            name: 'forum_list',
            component: () => import('@/pages/forum/list'),
            meta: {
                title: 'IDF论坛列表'
            }
        },
        {
            path: 'add',
            name: 'forum_add',
            component: () => import('@/pages/forum/add'),
            meta: {
                title: '添加论坛',
                need_path: '/pages/index/forum/list'
            }
        },
        {
            path: 'edit',
            name: 'forum_edit',
            component: () => import('@/pages/forum/edit'),
            meta: {
                title: '编辑论坛',
                need_path: '/pages/index/forum/list'
            }
        }
        ]
    },
    {
        path: 'enroll',
        component: () => import('@/pages/enroll/index'),
        meta: {
            title: '报名管理'
        },
        children: [{
            path: '/',
            redirect: 'member_list',
            component: () => import('@/pages/enroll/member_list')
        },
        {
            path: 'member_list',
            name: 'member_list',
            component: () => import('@/pages/enroll/member_list'),
            meta: {
                title: '会员列表'
            }
        },
        {
            path: 'upload_list',
            name: 'upload_list',
            component: () => import('@/pages/enroll/upload_list'),
            meta: {
                title: '用户上传列表'
            }
        },
        {
            path: 'entry',
            component: () => import('@/pages/enroll/entry/index'),
            meta: {
                title: '报名列表'
            },
            children: [{
                path: '/',
                redirect: 'entry_list',
                component: () =>
                    import('@/pages/enroll/entry/list')
            },
            {
                path: 'list',
                name: 'entry_list',
                component: () =>
                    import('@/pages/enroll/entry/list'),
                meta: {
                    title: '列表',
                    keepAlive: true
                }
            },
            {
                path: 'examine',
                name: 'examine',
                component: () =>
                    import('@/pages/enroll/entry/examine'),
                meta: {
                    title: '报名审核',
                    need_path: '/pages/index/enroll/entry/list'
                }
            },
            ]
        },
        {
            path: 'volunteer',
            component: () => import('@/pages/enroll/volunteer/index'),
            meta: {
                title: '志愿者列表'
            },
            children: [{
                path: '/',
                redirect: 'listVolunt',
                component: () =>
                    import('@/pages/enroll/volunteer/listVolunt')
            },
            {
                path: 'listVolunt',
                name: 'listVolunt',
                component: () =>
                    import('@/pages/enroll/volunteer/listVolunt'),
                meta: {
                    title: '列表',
                    keepAlive: true
                }
            },
            {
                path: 'examine',
                name: 'examineVolunt',
                component: () =>
                    import('@/pages/enroll/volunteer/examineVolunt'),
                meta: {
                    title: '查看',
                    need_path: '/pages/index/enroll/volunteer/listVolunt'
                }
            },
            ]
        },
        {
            path: 'media',
            component: () => import('@/pages/enroll/media/index'),
            meta: {
                title: '嘉宾/媒体列表'
            },
            children: [{
                path: '/',
                redirect: 'listMedia',
                component: () =>
                    import('@/pages/enroll/media/listMedia')
            },
            {
                path: 'listMedia',
                name: 'listMedia',
                component: () =>
                    import('@/pages/enroll/media/listMedia'),
                meta: {
                    title: '列表',
                    keepAlive: true
                }
            },
            {
                path: 'examine',
                name: 'examineMedia',
                component: () =>
                    import('@/pages/enroll/media/examineMedia'),
                meta: {
                    title: '查看',
                    need_path: '/pages/index/enroll/media/listMedia'
                }
            },
            ]
        },
        {
            path: 'notice',
            name: 'enroll_notice',
            component: () => import('@/pages/enroll/notice'),
            meta: {
                title: '作品须知'
            }
        }
        ]
    },
    {
        path: 'img',
        component: () => import('@/pages/img/index'),
        meta: {
            title: '轮播图管理'
        },
        children: [{
            path: '/',
            redirect: 'list',
            component: () => import('@/pages/img/list')
        },
        {
            path: 'list',
            name: 'img_list',
            component: () => import('@/pages/img/list'),
            meta: {
                title: '轮播图列表'
            }
        },
        {
            path: 'add',
            name: 'img_add',
            component: () => import('@/pages/img/add'),
            meta: {
                title: '添加轮播图',
                need_path: '/pages/index/img/list'
            }
        },
        {
            path: 'edit',
            name: 'img_edit',
            component: () => import('@/pages/img/edit'),
            meta: {
                title: '编辑轮播图',
                need_path: '/pages/index/img/list'
            }
        },
        {
            path: 'classify',
            name: 'img_classify_list',
            component: () => import('@/pages/img/classify'),
            meta: {
                title: '分类列表'
            }
        }
        ]
    },
    {
        path: 'rater',
        component: () => import('@/pages/rater/index'),
        meta: {
            title: '评委管理'
        },
        children: [{
            path: '/',
            redirect: 'list',
            component: () => import('@/pages/rater/list')
        },
        {
            path: 'list',
            name: 'rater_list',
            component: () => import('@/pages/rater/list'),
            meta: {
                title: '评委列表'
            }
        },
        {
            path: 'add',
            name: 'rater_add',
            component: () => import('@/pages/rater/add'),
            meta: {
                title: '添加评委',
                need_path: '/pages/index/rater/list'
            }
        },
        {
            path: 'edit',
            name: 'rater_edit',
            component: () => import('@/pages/rater/edit'),
            meta: {
                title: '编辑评委',
                need_path: '/pages/index/rater/list'
            }
        },
        {
            path: 'classify',
            name: 'rater_classify_list',
            component: () => import('@/pages/rater/classify'),
            meta: {
                title: '分类列表'
            }
        }
        ]
    },
    {
        path: 'setting',
        component: () => import('@/pages/setting/index'),
        meta: {
            title: '系统设置'
        },
        children: [{
            path: '/',
            redirect: 'siteInfo',
            component: () => import('@/pages/setting/siteInfo')
        },
        {
            path: 'siteInfo',
            name: 'siteInfo',
            component: () => import('@/pages/setting/siteInfo'),
            meta: {
                title: '站点信息'
            }
        },
        {
            path: 'year',
            name: 'year',
            component: () => import('@/pages/setting/year'),
            meta: {
                title: '年份设置'
            }
        },
        {
            path: 'lang',
            name: 'lang',
            component: () => import('@/pages/setting/lang'),
            meta: {
                title: '语言设置'
            }
        },
        {
            path: 'address',
            name: 'address',
            component: () => import('@/pages/setting/address'),
            meta: {
                title: '地点设置'
            }
        },
        {
            path: 'applicationGroup',
            name: 'applicationGroup',
            component: () => import('@/pages/setting/applicationGroup'),
            meta: {
                title: '申报组别设置'
            }
        },
        {
            path: 'prize',
            name: 'prize',
            component: () => import('@/pages/film/prize'),
            meta: {
                title: '奖项管理'
            }
        },
        {
            path: 'notify',
            name: 'notify',
            component: () => import('@/pages/setting/notify'),
            meta: {
                title: '消息通知'
            }
        },
        {
            path: 'user',
            name: 'user',
            component: () => import('@/pages/setting/user'),
            meta: {
                title: '用户管理'
            }
        },
        {
            path: 'authority',
            name: 'setting_authority',
            component: () => import('@/pages/setting/authority'),
            meta: {
                title: '角色管理'
            }
        },
        {
            path: 'backup',
            name: 'backup',
            component: () => import('@/pages/setting/backup'),
            meta: {
                title: '数据备份'
            }
        },
        {
            path: 'log',
            name: 'log',
            component: () => import('@/pages/setting/log'),
            meta: {
                title: '日志'
            }
        }
        ]
    },
    {
        path: 'message',
        component: () => import('@/pages/message/index'),
        meta: {
            title: '消息通知'
        },
        children: [{
            path: '/',
            redirect: 'list',
            component: () => import('@/pages/message/list')
        },
        {
            path: 'list',
            name: 'message_list',
            component: () => import('@/pages/message/list'),
            meta: {
                title: '消息列表'
            }
        },

        ]
    }
    ]
},
{
    path: '*',
    redirect: '/404'
}
];

export default rootConfig;


// WEBPACK FOOTER //
// ./src/router/modules/root.js